import React, { useEffect, useState } from 'react';
import { Button, Drawer, DrawerContent, DrawerFooter, DrawerHeader, DrawerTitle, DrawerTrigger } from '@zep-us/zus';
import { FilterIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { type PublicCategoryState, usePublicCategoryFilter } from '@/module/public/hooks';
import { useFilterSelectedValues } from '@/module/public/hooks/useFilterSelectedValues';
import { type PublicMetaState, usePublicMetaFilter } from '@/module/public/hooks/usePublicMetaFilter';
import { FilterContent } from './AsideFilter/FilterContent';
import { FilterHeader } from './AsideFilter/FilterHeader';
type AllState = PublicMetaState & PublicCategoryState;
export const DrawerFilter = () => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    handleAutoApply
  } = usePublicMetaFilter();
  const {
    t
  } = useTranslation(['common']);
  const {
    iSetFilters
  } = useFilterSelectedValues();
  const [tempFilter, setTempFilter] = useState<AllState | undefined>(undefined);
  const {
    state: metaState,
    handleMetaFilter
  } = usePublicMetaFilter();
  const {
    state,
    handleCategory
  } = usePublicCategoryFilter();
  const showFilterDrawer = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setIsOpen(true);
    handleAutoApply(false);
    setTempFilter({
      ...state,
      ...metaState
    });
  };
  const applyFilter = () => {
    setIsOpen(false);
    handleAutoApply(true);
    setTempFilter(undefined);
  };
  const closeFilterDrawer = () => {
    setIsOpen(false);
    handleAutoApply(true);
    // 켜져있을때의 state 로 복원
    if (tempFilter) {
      handleMetaFilter({
        ...tempFilter
      });
      handleCategory({
        ...tempFilter
      });
    }
    setTempFilter(undefined);
  };

  // 반응형으로 해당 컴포넌트가 렌더링 되는 시점에 초기화
  useEffect(() => {
    return () => {
      handleAutoApply(true);
    };
  }, [handleAutoApply]);
  return <Drawer aria-describedby={'drawer-content'} open={isOpen} onOpenChange={open => {
    if (!open) closeFilterDrawer();
  }} data-sentry-element="Drawer" data-sentry-component="DrawerFilter" data-sentry-source-file="DrawerFilter.tsx">
      <DrawerTrigger asChild data-sentry-element="DrawerTrigger" data-sentry-source-file="DrawerFilter.tsx">
        <Button size={'md'} intent={'neutral'} variant={'outlined'} rounded={'full'} onClick={showFilterDrawer} leftSlot={<FilterIcon size={'sm'} />} data-sentry-element="Button" data-sentry-source-file="DrawerFilter.tsx">
          {t('common:public.filter')}
          {iSetFilters && <div className={'flex h-[20px] items-start '}>
              <DotIcon />
            </div>}
        </Button>
      </DrawerTrigger>
      <DrawerContent onDimClick={closeFilterDrawer} className={'inset-x-0 top-[64px] z-50 mt-0 flex h-full flex-col rounded-none bg-white focus:outline-none'} data-sentry-element="DrawerContent" data-sentry-source-file="DrawerFilter.tsx">
        <DrawerHeader className={'bg-white p-none'} data-sentry-element="DrawerHeader" data-sentry-source-file="DrawerFilter.tsx">
          <DrawerTitle data-sentry-element="DrawerTitle" data-sentry-source-file="DrawerFilter.tsx">
            <FilterHeader onClose={closeFilterDrawer} data-sentry-element="FilterHeader" data-sentry-source-file="DrawerFilter.tsx" />
          </DrawerTitle>
        </DrawerHeader>
        <div className={'flex flex-col gap-xs overflow-y-auto bg-white pb-[50px]'}>
          <FilterContent data-sentry-element="FilterContent" data-sentry-source-file="DrawerFilter.tsx" />
        </div>
        <DrawerFooter className={'sticky bottom-0 bg-white p-md'} data-sentry-element="DrawerFooter" data-sentry-source-file="DrawerFilter.tsx">
          <Button size={'md'} className={'w-full'} onClick={applyFilter} data-sentry-element="Button" data-sentry-source-file="DrawerFilter.tsx">
            {t('common:common.apply')}
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>;
};
const DotIcon = () => {
  return <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="DotIcon" data-sentry-source-file="DrawerFilter.tsx">
      <circle id="Ellipse 1" cx="2.5" cy="2.5" r="2.5" fill="#FF4848" data-sentry-element="circle" data-sentry-source-file="DrawerFilter.tsx" />
    </svg>;
};